const customer_messages = {
  title: ['customers>>title', 'Customers'],
  description: ['customers>>description', 'View customer organisations and onboard new customers that will be managed internally.'],
  onboard_button: ['customers>>onboard_button', 'Onboard new customer'],
  export_csv: ['customers>>export_csv', 'Export CSV'],
  export_invoice_csv: ['customers>>export_invoice_csv', "Export last month's invoice CSV"],
  organization: ['customers>>organization', 'Organization'],
  organization_number: ['customers>>organization_number', 'Registration number'],
  owner: ['customers>>owner', 'Owner'],
  administrators: ['customers>>administrators', 'Administrators'],
  active_users: ['customers>>active_users', 'Active users'],
  payment_method: ['customers>>payment_method', 'Payment method'],
  billing_status: ['customers>>billing_status', 'Billing status'],
  created: ['customers>>created', 'Created'],
  onboarding_type: ['customers>>onboarding_type', 'Onboarding type'],
  created_by: ['customers>>created_by', 'Created by'],
  status: ['customers>>status', 'Status'],
  filters_status: ['customers>>filters>>status', 'Status'],
  filters_payment_method: ['customers>>filters>>payment_method', 'Payment method'],
  filters_onboarding_type: ['customers>>filters>>onboarding_type', 'Onboarding type'],
  all: ['customers>>all', 'All'],
  active: ['customers>>active', 'Active'],
  archived: ['customers>>archived', 'Archived'],
  invoice: ['customers>>invoice', 'Invoice'],
  stripe: ['customers>>stripe', 'Stripe'],
  internal: ['customers>>internal', 'Internal onboarding'],
  self_service: ['customers>>self_service', 'Self-service'],
  managed_externally: ['customers>>managed_externally', 'Managed externally'],
  owner_missing: ['customers>>owner_missing', 'Owner missing'],
  owner_inactive: ['customers>>owner_inactive', 'Owner inactive'],
  owner_active: ['customers>>owner_active', 'Owner active'],
  onboarding_dialog_title: ['customers>>dialog>>title', 'Onboard new customer'],
  organization_section: ['customers>>dialog>>organization_section', 'Organization'],
  owner_section: ['customers>>dialog>>owner_section', 'Owner'],
  administrator_section: ['customers>>dialog>>administrator_section', 'Administrator'],
  add_administrator: ['customers>>dialog>>add_administrator', 'Add administrator'],
  force_duplicate_name: ['customers>>dialog>>force_duplicate_name', 'Continue despite duplicate organisation name'],
  country: ['customers>>dialog>>country', 'Country'],
  business_type: ['customers>>dialog>>business_type', 'Business type'],
  organization_size: ['customers>>dialog>>organization_size', 'Organization size'],
  language: ['customers>>dialog>>language', 'Language'],
  cancel: ['customers>>dialog>>cancel', 'Cancel'],
  confirm: ['customers>>dialog>>confirm', 'Create customer'],
  created_success: ['customers>>dialog>>created_success', 'Customer onboarding completed.'],
};

export default customer_messages;
